import { Component, inject, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { SystemStatusService } from '@/app/core/service/system-status.service';

@Component({
    selector: 'app-maintenance-mode',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './maintenance-mode.component.html',
    styleUrls: ['./maintenance-mode.component.scss'],
})
export class MaintenanceModeComponent implements OnInit, OnDestroy {
    private readonly systemStatus = inject(SystemStatusService);
    private readonly router = inject(Router);
    private sub?: Subscription;

    message = '';
    currentYear = new Date().getFullYear();

    ngOnInit(): void {
        this.message = this.systemStatus.maintenance.message;

        // Cuando el backend desactive el mantenimiento, redirigir al inicio
        this.sub = this.systemStatus.maintenanceEnabled$.subscribe((enabled) => {
            this.message = this.systemStatus.maintenance.message;
            if (!enabled) {
                this.router.navigate(['/']);
            }
        });
    }

    ngOnDestroy(): void {
        this.sub?.unsubscribe();
    }
}
